import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-training-course-details-dev-ops',
  templateUrl: './training-course-details-dev-ops.component.html',
  styleUrls: ['./training-course-details-dev-ops.component.scss']
})
export class TrainingCourseDetailsDevOpsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
